export const selectOpportunityToProposalData = (state) =>
  state.capture.opportunityToProposal.data;

export const selectOpportunityToProposalLoading = (state) =>
  state.capture.opportunityToProposal.isLoading;

export const selectOpportunityToProposalError = (state) =>
  state.capture.opportunityToProposal.error;
